export default {

  tipoPlanilha: {
    value: null,
    state: null,
    required: false,
    options: [
      {value: null, text: 'Todas as planilhas'},
      {value: 'ANOTACOESNEGATIVAS', text: 'ANOTAÇÕES NEGATIVAS'},
      {value: 'ASSOCIADOS', text: 'ASSOCIADOS'},
      {value: 'CHEQUE', text: 'CHEQUE'},
      {value: 'CARTAODECREDITO', text: 'CARTÃO DE CRÉDITO'},
      {value: 'ENDIVIDAMENTO', text: 'ENDIVIDAMENTO'},
      {value: 'GARANTIADEOPERACOES', text: 'GARANTIA DE OPERAÇÕES'},
      {value: 'GRUPOECONOMICO', text: 'GRUPO ECONÔMICO'},
      {value: 'IAP', text: 'IAP'},
      {value: 'MOVIMENTACAODIARIACONTA', text: 'MOVIMENTAÇÃO DIARIA CONTA'},
      {value: 'PAGAMENTOPARCELA', text: 'PAGAMENTO PARCELA'},
      {value: 'PROPRIEDADES', text: 'PROPRIEDADES'},
      {value: 'SALDOMEDIOCAPTACAO', text: 'SALDO MÉDIO CAPTAÇÃO'},
      {value: 'SALDOMEDIOCCO', text: 'SALDO MÉDIO CCO'}
    ]
  },
  statusImport: {
    value: null,
    state: null,
    required: false,
    options: [
      {value: null, text: 'Todos os status'},
      {value: 'SUCESSO', text: 'Sucesso'},
      {value: 'PROCESSANDO', text: 'Processando'},
      {value: 'AGUARDANDO_PROCESAMENTO', text: 'Aguardando Processamento'},
      {value: 'FALHA', text: 'Falha'},
      {value: 'CANCELADO', text: 'Cancelado'}
    ]
  }
}



// WEBPACK FOOTER //
// ./src/views/private/import/components/search/search-form.js